import { useTranslation } from "@outschool/localization";

export const usePlaceholderSuggestions = () => {
  const { t } = useTranslation(
    "ui-components-website\\search\\useSearchWithSuggestions"
  );
  return [
    {
      uid: "1",
      name: t("Full curriculum"),
      value: "Full curriculum",
      category: "Full Curriculum",
      type: "placeholder",
    },
    {
      uid: "2",
      name: t("ADHD"),
      value: "ADHD",
      category: "Health & Wellness",
      type: "placeholder",
    },
    {
      uid: "3",
      name: t("Multiplication"),
      value: "Multiplication",
      category: "Math",
      type: "placeholder",
    },
    {
      uid: "4",
      name: t("Creative writing"),
      value: "Creative writing",
      category: "English Language Arts",
      type: "placeholder",
    },
    {
      uid: "5",
      name: t("Book clubs"),
      value: "Book clubs",
      category: "English Language Arts",
      type: "placeholder",
    },
    {
      uid: "6",
      name: t("Spanish"),
      value: "Spanish",
      category: "Languages",
      type: "placeholder",
    },
  ];
};
